import React from 'react';
import LaptopChromebookIcon from '@mui/icons-material/LaptopChromebook';
import DescriptionIcon from '@mui/icons-material/Description';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CloseIcon from '@mui/icons-material/Close';

const OPTIONS = [
  {
    value: 'cbt',
    title: 'Computer-Based (CBT)',
    description: 'Students answer on computers or other compatible devices. Exam is timed, proctored, automatically graded, and analytics remain available.',
    Icon: LaptopChromebookIcon,
  },
  {
    value: 'manual',
    title: 'Manual + AI Script Grading',
    description: 'Students write on paper. Upload the completed script later so Bubble Ai can extract, grade, and prepare the same performance analytics.',
    Icon: DescriptionIcon,
    beta: true,
  },
  {
    value: 'manual_scores',
    title: 'Manual Score Entry',
    description: 'Build exam/test here as usual. Students complete the assessment outside Bubble Ai, then record each student\'s answer or marks per question without uploading a script.',
    Icon: FactCheckIcon,
  },
];

export default function ExamModeChoiceModal({ css, onSelect, onClose }) {
  return (
    <div className={css.modalOverlay} onClick={onClose}>
      <div className={`${css.modalLarge} BubblePopIn`} style={{ maxWidth: 920 }} onClick={event => event.stopPropagation()}>
        <div className={css.modalHeader}>
          <div>
            <h2 className={css.modalTitle}>How will your students take this exam?</h2>
            <p className={css.modalSub}>
              Choose how students will complete this exam: online, on paper with AI grading, or through teacher-entered scores.
            </p>
          </div>
          <button className={css.closeBtn} type="button" onClick={onClose} aria-label="Close">
            <CloseIcon fontSize="small" />
          </button>
        </div>
        <div className={css.modalBody}>
          <div className={css.examModeGrid}>
          {OPTIONS.map(({ value, title, description, Icon, beta }) => (
            <button
              key={value}
              type="button"
              className={css.examModeCard}
              onClick={() => onSelect(value)}
            >
              <Icon className={css.examModeIcon} />
              <span className={css.examModeCardName}>{title} {beta && <span className={css.examModeBetaTag}>Beta release</span>}</span>
              <span className={css.examModeCardDesc}>{description}</span>
              <span className={css.examModeCardAction}>Choose {value === 'cbt' ? 'CBT' : value === 'manual' ? 'Manual' : 'Score Entry'}</span>
            </button>
          ))}
          </div>
        </div>
      </div>
    </div>
  );
}
